// tslint:disable:max-line-length
import * as React from 'react';
import { createIcon } from '../createIcon';

function HeartFilled() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "22",
    viewBox: "0 0 24 22"
  }, /*#__PURE__*/React.createElement("path", {
    "data-fill-rule": "fillStroke",
    strokeLinecap: "square",
    strokeWidth: "2",
    d: "M21.243 2.757a6 6 0 0 0-9.242.927 6 6 0 1 0-9.242 7.558L12 20.485l9.243-9.243a6 6 0 0 0 0-8.485z"
  }));
}

export var HeartFilledIcon = createIcon(HeartFilled, {
  defaultColor: 'E84260'
}); // tslint:enable:max-line-length